import createModel, { prop } from './lib/create_model';

const GuideCollection = createModel({
  modelName: 'GuideCollection',
  properties: {
    id: prop(String).isRequired,
    name: prop(String).isRequired,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default GuideCollection;
